import {
  ExpenseCategoryType,
  ExpenseClaimState,
  ExpenseSubCategory,
  VisitAttendance,
  VisitType
} from './../../../core/models/expense.model';
import { ExpenseClaimPaymentMethod } from 'app/core/models/expense.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExpenseClaimPaidBy, ExpenseClaimViewModel } from '../../../core/models/expense.model';
import { AuthService } from '../../../core/services/auth.service';
import { Permissions } from '../../../core/constants/permissions';
import { StringHelper } from '../../../core/helpers/string-helper';
import { Lightbox } from "ngx-lightbox";
import { OverBudgetRequestDetailsStatus } from 'app/core/models/project-management.model';

@Component({
  selector: 'app-expense-card',
  templateUrl: './expense-card.component.html',
  styleUrls: ['./expense-card.component.scss']
})
export class ExpenseCardComponent implements OnInit {
  @Input('expense') expense: ExpenseClaimViewModel;
  @Input('showExpensePaidBy') showExpensePaidBy: boolean = false;
  @Input('showReasonForEdit') showReasonForEdit: boolean = true;
  @Input('showInvestigation') showInvestigation: boolean = true;
  @Input('showApproveOptions') showApproveOptions: boolean = true;
  @Input('showDescription') showDescription: boolean = true;
  @Input('showImages') showImages: boolean = true;
  @Input('trialPolicyName') trialPolicyName: string;
  @Input('trialPolicyId') trialPolicyId: string;

  @Output('onEdit') onEdit = new EventEmitter();
  @Output('onViewPolicy') onViewPolicy = new EventEmitter();

  Permissions = Permissions;
  stringHelper = StringHelper;
  ExpenseClaimPaymentMethod = ExpenseClaimPaymentMethod;
  ExpenseClaimState = ExpenseClaimState;
  ExpenseCategoryType = ExpenseCategoryType;
  ExpenseSubCategory = ExpenseSubCategory;
  VisitType = VisitType;
  VisitAttendance = VisitAttendance;
  OverBudgetRequestDetailsStatus = OverBudgetRequestDetailsStatus;


  constructor(public authService: AuthService, private lightbox: Lightbox){
  }

  ngOnInit(): void {
  }

  onStartInvestigation(expenseId: string): void {
  }

  onCloseInvestigation(expenseId: string): void {
  }

  viewReceipt(imageUrl: string) {
    const album: { src: string, caption: string, thumb: string, downloadUrl: string }[] = [];
    album.push({ src: imageUrl, caption: '', thumb: imageUrl, downloadUrl: '' });

    this.lightbox.open(album, 0);
  }

  getPaidByText(paidBy: ExpenseClaimPaidBy) {
    switch (paidBy) {
      case ExpenseClaimPaidBy.Finance:
        return 'Paid via Finance';
      case ExpenseClaimPaidBy.Caxton:
        return 'Paid via Caxton Bank';
      case ExpenseClaimPaidBy.CaxtonCard:
        return 'Paid via Caxton Card';
      case ExpenseClaimPaidBy.NmibleCard:
        return 'Paid via Nmible Card';
      case ExpenseClaimPaidBy.NmibleBank:
        return 'Paid via Nmible Bank';
    }
  }

  onApproveExpenseClaim(expenseId: string, type: ExpenseCategoryType) {
  }

  onMarkAsPaid(expenseId: string) {
  }

  onRejectModal(expenseId: string) {
  }

  getPatientAddress(address: string | null, country: string | null): string {
    const formattedAddress = address ?? '';
    const lastTwoCharsOfAddress = formattedAddress.slice(-2);

    return country && country !== '' && country !== lastTwoCharsOfAddress
      ? `${formattedAddress}, ${country}`
      : formattedAddress;
  }

  onNavigateToPatient() {
    location.href = `/patient/${this.expense.patientTrialId}`;
  }

  get hasAiReceiptData(): boolean {
    return this.expense.receipts?.length > 0 && this.expense.receipts.some(r => r.amount != null);
  }

  get receiptTotal(): number {
    if (!this.hasAiReceiptData) return 0;
    return this.expense.receipts
      .filter(r => r.amount != null)
      .reduce((sum, r) => sum + r.amount, 0);
  }

  get receiptAmountMatches(): boolean {
    return this.hasAiReceiptData &&
      Math.round(this.receiptTotal * 100) === Math.round(this.expense.amount * 100) &&
      this.receiptCurrencyMatches;
  }

  get receiptCurrencyMatches(): boolean {
    if (!this.hasAiReceiptData) return false;
    return this.expense.receipts
      .filter(r => r.amount != null && r.currency)
      .every(r => r.currency === this.expense.currency);
  }

  get receiptCategoryMatches(): boolean {
    if (!this.hasAiReceiptData) return false;
    return this.expense.receipts
      .filter(r => r.amount != null && r.categoryName)
      .every(r => r.categoryName === this.expense.categoryName);
  }

  get categoryMismatchReason(): string {
    const categories = [...new Set(
      this.expense.receipts
        .filter(r => r.amount != null && r.categoryName)
        .map(r => r.categoryName)
    )];
    return `AI categorised receipt as "${categories.join(', ')}" but claim category is "${this.expense.categoryName}"`;
  }

  get receiptMismatchReason(): string {
    const reasons: string[] = [];
    const processedReceipts = this.expense.receipts.filter(r => r.amount != null);

    if (!this.receiptCurrencyMatches) {
      const currencies = [...new Set(processedReceipts.filter(r => r.currency).map(r => r.currency))];
      reasons.push(`Receipt currency (${currencies.join(', ')}) does not match claim currency (${this.expense.currency})`);
    }

    const total = this.receiptTotal;
    if (Math.round(total * 100) !== Math.round(this.expense.amount * 100)) {
      reasons.push(`Receipt total (${total.toFixed(2)}) does not match claim amount (${this.expense.amount.toFixed(2)})`);
    }

    return reasons.join('. ');
  }

}
